import { Link } from "react-router-dom";
import { useAdminOverview } from "@/hooks/useAdmin";
import { AdminHeading } from "@/components/admin/AdminLayout";

const sum = (o = {}) => Object.values(o).reduce((a, b) => a + b, 0);

export default function AdminOverview() {
  const { data: o } = useAdminOverview();
  if (!o) return <p className="text-[11px] uppercase tracking-[0.24em] text-charcoal/50">Loading…</p>;
  const cards = [
    { label: "Pending stories", value: o.stories?.pending || 0, to: "/admin/stories", hint: "awaiting moderation" },
    { label: "Applications to review", value: (o.applications?.submitted || 0) + (o.applications?.under_review || 0), to: "/admin/applicants", hint: "submitted · under review" },
    { label: "Awaiting dispatch", value: o.trials?.awaiting_dispatch || 0, to: "/admin/dispatch", hint: "accepted invitations" },
    { label: "Trials in progress", value: o.trials?.in_progress || 0, to: "/admin/dispatch?status=in_progress", hint: `${o.checkins_saved} check-ins saved` },
    { label: "Programmes", value: sum(o.programmes), to: "/admin/programmes", hint: `${o.programmes?.open || 0} open` },
    { label: "Members", value: o.members, hint: `${o.open_support_cases} open deletion requests` },
  ];
  return (
    <div data-testid="admin-overview">
      <AdminHeading eyebrow="Workspace" title="Overview" />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map((c) => {
          const inner = (
            <>
              <p className="text-[10px] uppercase tracking-[0.22em] text-champagne">{c.label}</p>
              <p className="mt-3 font-serif text-5xl text-forest font-light" data-testid={`overview-${c.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{c.value}</p>
              <p className="mt-2 text-xs text-charcoal/50 font-light">{c.hint}</p>
            </>
          );
          return c.to
            ? <Link key={c.label} to={c.to} className="block border border-forest/15 bg-cream p-6 hover:border-forest/50 transition-colors">{inner}</Link>
            : <div key={c.label} className="border border-forest/15 bg-cream p-6">{inner}</div>;
        })}
      </div>
      <div className="mt-10 grid md:grid-cols-3 gap-4 text-sm">
        {[["Applications", o.applications], ["Trials", o.trials], ["Stories", o.stories]].map(([t, m]) => (
          <div key={t} className="border border-forest/10 p-5">
            <p className="text-[10px] uppercase tracking-[0.22em] text-charcoal/50">{t} by status</p>
            <dl className="mt-3 space-y-1.5">
              {Object.entries(m || {}).length === 0 && <p className="text-charcoal/40 font-light">None yet</p>}
              {Object.entries(m || {}).map(([k, v]) => <div key={k} className="flex justify-between"><dt className="text-charcoal/65 font-light">{k.replace("_", " ")}</dt><dd className="text-forest">{v}</dd></div>)}
            </dl>
          </div>
        ))}
      </div>
    </div>
  );
}
